import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-aside-content',
  templateUrl: './aside-content.component.html',
  styleUrls: ['./aside-content.component.scss'],
  animations: [
    trigger(('viewState'), [
      state('active', style({
        transform: 'translateX(0px)'
      })),
      state('inactive', style({
        transform: 'translateX(-{{width}})'
      }), {params: { width: '260px'}}),
      transition('active => inactive', animate('300ms ease-out')),
      transition('inactive => active', animate('300ms ease-in'))
    ])
  ]
})

export class AsideContentComponent implements OnInit {
  open: string;
  width: string;

  constructor() { }

  ngOnInit() { }

}
